import React, { useEffect, useState } from 'react';
import AdminPollVoteCardView from "./admin-poll-vote-card.view";
import { useNavigate } from 'react-router-dom';
import { Poll, Vote } from "../../../domains/models/poll";
import server from "../../../server";
import "../../../styles/component/dashboard/dashboard-cards.scss";


const AdminPollVoteCard = () => {

    const navigate = useNavigate();
    const [data, setData] = useState<Vote[] | Poll[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        fetchData();
    }, []);


    async function fetchData() {
        setIsLoading(true);
        const res = await server.poll.search({
            'active': true,
            "sortBy": "CREATED_ON",
            "sortDirection":'DESC'
        });

        setData(res);
        setIsLoading(false);

    }

    const navigateToPollsVote = () => {
        navigate('/poll')
    }

    return (
        <AdminPollVoteCardView
            navigateToPollsVote={navigateToPollsVote}
            isLoading={isLoading}
            data={data}
        />
    )


}

export default AdminPollVoteCard;
